<template>
  <TransitionRoot as="template" v-bind:show="sidebarOpen">
    <Dialog as="div" class="relative z-40 vertical:hidden" v-on:close="sidebarOpen = false">
      <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-600 bg-opacity-75" />
      </TransitionChild>

      <div class="fixed inset-0 flex z-40">
        <TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
          <DialogPanel class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-gray-800">
            <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
              <div class="absolute top-0 right-0 -mr-12 pt-2">
                <button type="button" class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" v-on:click="sidebarOpen = false">
                  <span class="sr-only">Close sidebar</span>
                  <XMarkIcon class="h-6 w-6 text-white" aria-hidden="true" />
                </button>
              </div>
            </TransitionChild>

            <Logo class="text-gray-300" />

            <div class="mt-5 flex-1 h-0 overflow-y-auto">
              <nav class="px-2">
                <div class="space-y-1">
                  <Link v-for="item in navigation" v-bind:href="item.url" v-bind:class="[item.active ? 'active' : undefined, 'group nav-link']" v-bind:aria-current="item.current ? 'page' : undefined">
                    {{ item.title }}
                  </Link>
                </div>

                <div v-if="context?.children.length" class="mt-10">
                  <p class="context-menu-header">{{ context.title }}</p>
                  <div class="submenu-nav-items">
                    <div v-for="item in context.children">

                      <div v-if="item.children.length" class="mt-8">
                        <div class="space-y-4">
                          <div class="submenu-nav-header">{{ item.title }}</div>

                          <div class="submenu-nav-items">
                            <Link v-for="subItem in item.children" v-bind:href="subItem.url" v-bind:class="[subItem.active ? 'active' : undefined, 'group nav-link']" v-bind:aria-current="subItem.current ? 'page' : undefined">
                              <span class="truncate">
                                {{ subItem.title }}
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>

                      <template v-else>
                        <Link v-bind:href="item.url" v-bind:class="[item.active ? 'active' : undefined, 'group nav-link']" v-bind:aria-current="item.current ? 'page' : undefined">
                          <span class="truncate">
                            {{ item.title }}
                          </span>
                        </Link>
                      </template>

                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </DialogPanel>
        </TransitionChild>
        <div class="flex-shrink-0 w-14" aria-hidden="true">
          <!-- Dummy element to force sidebar to shrink to fit close icon -->
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { usePage, Link } from "@inertiajs/vue3";
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import Logo from "./Logo";

export default {
  components: {
    Dialog,
    DialogPanel,
    Link,
    Logo,
    TransitionChild,
    TransitionRoot,
    XMarkIcon,
  },
  data () {
    return {
      sidebarOpen: false,
    }
  },
  mounted (){
    this.emitter.on("toggle-sidebar", isOpen => {
      this.sidebarOpen = isOpen;
    });
  },
  computed: {
    navigation () {
      return usePage().props.navigation;
    },
    context () {
      return usePage().props.navigation.find(item => item.active);
    },
  },
}

</script>
